import { ec2Option } from './options/ec2';
import { fargateOption } from './options/fargate';
import { batchOption } from './options/batch';
import { glueOption } from './options/glue';
import { lambdaOption } from './options/lambda';

import { Option } from '../../../shared/options/domain/option';
import { CriteriaKey } from './criteria';

export const computeOptions: Record<string, Option<CriteriaKey>> = {
  ec2Option,
  fargateOption,
  batchOption,
  glueOption,
  lambdaOption,
};
